class Transfer {
  constructor({ id }) {
    this.id = id;
  }
}

export default Transfer;
